import React, { useState, useEffect } from "react";
import Topbar from "../component/Topbar";
import Hero from "../component/Hero";
import Info from "../component/Info";
import Founder from "../component/Founder";
import Faqs from "../component/Faqs";
import PageCount from "../component/utils/PageCount";
 
function Home() {
 
  return (
    <>


    <PageCount pageName = {"Home"}/>
      {/* <Topbar /> */}
      <Hero/>
      <Info/>
      {/* <Founder/> */}
      <Faqs/>
       
    </>
  );
}

export default Home;
